import { useEffect, useRef, useState } from "react";
import { roundToUnit } from "../../classes/utils/NumbersUtils";
import "./MeasurementDisplay.css";

const MeasurementDisplay = ({
  value,
  unit,
  disabled,
  onChange,
  debounceMs = 0,
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState("");
  const debounceTimerRef = useRef(null);
  const isEditable = onChange && !disabled;

  useEffect(() => {
    if (isEditing) {
      setEditValue(roundToUnit(value)?.toString() || "0");
    }
  }, [isEditing, value]);

  const handleClick = () => {
    if (isEditable) {
      setIsEditing(true);
      setEditValue(roundToUnit(value)?.toString() || "0");
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
    const numValue = parseFloat(editValue);
    if (!isNaN(numValue) && numValue !== value) {
      if (debounceMs > 0) {
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        debounceTimerRef.current = setTimeout(() => {
          onChange(numValue);
        }, debounceMs);
      } else {
        onChange(numValue);
      }
    }
  };

  const handleKeyDown = e => {
    if (e.key === "Enter") {
      e.target.blur();
    } else if (e.key === "Escape") {
      setIsEditing(false);
      setEditValue(roundToUnit(value)?.toString() || "0");
    }
  };

  const handleChange = e => {
    setEditValue(e.target.value);
  };

  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  if (isEditing) {
    return (
      <div
        className={`measurement-display editing ${disabled ? "disabled" : ""}`}
      >
        <input
          type="number"
          className="measurement-value-input App-text-large"
          value={editValue}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          autoFocus
        />
        <span className="measurement-unit App-text-large">{unit}</span>
      </div>
    );
  }

  return (
    <div
      className={`measurement-display ${disabled ? "disabled" : ""} ${
        isEditable ? "editable" : ""
      }`}
      onClick={handleClick}
      style={isEditable ? { cursor: "pointer" } : {}}
    >
      <span className="measurement-value App-text-large">
        {value == null || (typeof value === "number" && isNaN(value))
          ? "-"
          : roundToUnit(value)}
      </span>
      {value != null && !(typeof value === "number" && isNaN(value)) && (
        <span className="measurement-unit App-text-large">{unit}</span>
      )}
    </div>
  );
};

export default MeasurementDisplay;
